import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { Cartonization_ModuleContextService } from './Cartonization.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class Cartonization_cartonization_strategies_dd_ComponentContextService {
  private readonly moduleContext: Cartonization_ModuleContextService;

  constructor(moduleContext: Cartonization_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'cartonization_strategies_dd',
      type: ComponentType.selector
    }
  }
}